import { Box, Paper, Popover, styled } from '@mui/material';

export const OptionIconSelectorBox = styled(Box, {
  shouldForwardProp: prop => prop !== 'hasError'
})<{ hasError?: boolean }>(({ hasError }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  border: `1px solid ${hasError ? 'red' : '#D0D5DD'}`,
  borderRadius: '8px',
  padding: '6px 10px',
  cursor: 'pointer',
  width: 'fit-content',
  backgroundColor: '#FFF',
  '&:hover': {
    borderColor: hasError ? 'red' : '#B0B5BD'
  }
}));

export const PlaceholderIconOptionBox = styled(Box)(({ theme }) => ({
  width: 24,
  height: 24,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#9CA3AF',
  borderRadius: '8px',
  fontSize: 12
}));

export const IconOptionBox = styled(Box)({
  width: 32,
  height: 32,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '8px',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#F0F0F0'
  }
});
export const IconPopover = styled(Popover)({
  '& .MuiPaper-root': {
    marginTop: 8,
    padding: 8,
    width: 140,
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    alignItems: 'flex-start',
    gap: 8
  }
});
